import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'html-react-parser';
import { Link } from 'react-router-dom';
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from 'react-redux';
import { Button, CircularProgress } from '@material-ui/core';

import userService from '../../services/userService';
import { markUserNotificationAllRead } from '../../store/slices/user';
import defaultImage from '../../assets/images/default/list_box.jpg';

const NotificationDropDown = (props) => {
    
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { loading } = useSelector((state) => state.user);
    const [isFetching, setIsFetching] = useState(false);
    const [items, setItems] = useState([]);

    const [page, setPage] = useState(0);
    //we need to know if there is more data
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        setItems((prevItems) => {
            return [...new Set([...props.notificationDescriptions])];
        });
        setPage(props.notifications.current_page)
        setHasMore(props.notifications.last_page > props.notifications.current_page);
    }, [props.notificationDescriptions]);

    const handleAllRead = () => {
        dispatch(markUserNotificationAllRead())
            .unwrap()
            .then((res) => {
                if(res) {
                    enqueueSnackbar('All notifications mark as read.', {
                        variant: 'success',
                        autoHideDuration: 5000,
                    });
                }
            })
            .catch((error) => {
                if(error) {
                    enqueueSnackbar('Woops! Something went wrong.', {
                        variant: 'error',
                        autoHideDuration: 5000,
                    });
                }
            })
    }

    const loadMoreNotifications = async (isUser) => {
        setIsFetching(true); 
        userService.getNotifications(page, 'web')
            .then((res) => {
                setItems((prevItems) => {
                    return [...new Set([...prevItems, ...res.data.data.notificationDescriptions])];
                });
                setPage(res.data.data.notifications.current_page);
                setHasMore(res.data.data.notifications.last_page > res.data.data.notifications.current_page);            
                setIsFetching(false);
            })
            .catch((error) => {
                setIsFetching(false); 
                if(error) {
                    enqueueSnackbar('Woops! Something went wrong.', {
                        variant: 'error',
                        autoHideDuration: 5000,
                    });
                }
            })
    }

    function addDefaultSrc(e) {
        e.target.src = defaultImage;
    }

    return (
        <div className={props.isNotiModalOpen ? "header-modal vis-wishlist notification-wrapper fadeIn-scroll" : "header-modal novis_wishlist notification-wrapper fadeOut-scroll"}> 
            <div className="my-notification">
		        <div className="header-noti">
			        <h4>Notifications</h4>
                    {!loading && (
		                <Link to="#" onClick={() => handleAllRead()}>Mark all as read</Link>
                    )}
                    {loading && (
                        <CircularProgress size={24} color="secondary" />
                    )}
		        </div>
                {items && (
                    <div className="body-noti">
                        {items.length > 0 ?
                            <>
                                {items.map((noti, index) => 
                                    <div className={noti.isRead === 0 ? "noti-one unread-bg" : "noti-one"} key={index}>
                                        <div className="icon-notiBox">
                                            {/* <i className={noti.icon}></i>  */}
                                            <img 
                                                src={noti.photo} 
                                                alt="mulk.pk"
                                                onError={addDefaultSrc} 
                                            /> 
                                        </div>
                                        <div className="textnoti-box">
                                            {ReactHtmlParser(noti.notification)}
                                            <span><i className="fas fa-mobile-alt"></i> {noti.date}</span>
                                        </div>
                                    </div>
                                )}
                            </>
                            :
                            <div className="noti-one">
                                <div className="textnoti-box">
                                    No notification found.
                                    {/* <span><i className="fas fa-mobile-alt"></i> {noti.date}</span> */}
                                </div>
                            </div>
                        }
                        <div className="LoadMoreCTA"> 
                            {!isFetching && hasMore && (
                                <Button 
                                    variant="outlined" 
                                    fullWidth
                                    color="secondary"
                                    onClick={() => loadMoreNotifications()}
                                >
                                    Load More
                                </Button>
                            )}
                            {isFetching && (
                                <Button
                                    variant="outlined" 
                                    fullWidth
                                    color="secondary"
                                >
                                    <CircularProgress color="secondary" size={24} />
                                </Button>
                            )}
                        </div>
                    </div>
                )}  
		    </div>
        </div>
    );
};

export default NotificationDropDown;